import { Card, Checkbox, Col, Image, Modal, Row, Table } from "antd";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import logoImage from "./../../../images/logo/logoui2.png";

const ModalPreviewPDF = ({ showOpen, setShowOpen, selectedInvoice }) => {
  const reportTemplateRef = useRef(null);
  const [totalSum, setTotalSum] = useState(0);
  const [totalSumInteres, setTotalSumInteres] = useState(0);
  const [totalInteres, settotalInteres] = useState(0);
  const [filteredData, setFilteredData] = useState([]);

  const handleGeneratePdf = async () => {
    const doc = new jsPDF({
      orientation: "p",
      unit: "pt",
    });

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    const element = reportTemplateRef.current;

    // Obtener la imagen renderizada del contenido
    const canvas = await html2canvas(element);

    // Obtener las dimensiones de la imagen
    const imgWidth = pageWidth;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    // Agregar la imagen al PDF
    doc.addImage(
      canvas.toDataURL("image/png"),
      "PNG",
      0,
      0,
      // imgWidth,
      // imgHeight
      593.6,
      595.2
    );

    const currentDate = new Date();
    const formattedDate = currentDate.toLocaleString().replace(/[/:]/g, "");
    doc.save(`factura ${selectedInvoice.invoiceNumber} ${formattedDate}`);
  };

  // const handleGeneratePdf = async () => {
  //   const doc = new jsPDF({
  //     orientation: "l",
  //     unit: "pt",
  //   });

  //   const pageWidth = doc.internal.pageSize.getWidth();
  //   const pageHeight = doc.internal.pageSize.getHeight();

  //   const element = reportTemplateRef.current;
  //   element.style.width = `${pageWidth}px`;
  //   element.style.height = `${pageHeight}px`;

  //   doc.setFont("Inter-Regular", "normal");

  //   doc.html(element, {
  //     async callback(doc) {
  //       doc.save(`factura ${selectedInvoice.invoiceNumber}`);
  //     },
  //   });
  // };

  useEffect(() => {
    if (selectedInvoice) {
      const newTotalSum = Object.values(selectedInvoice?.detail).reduce(
        (accumulator, employee) =>
          accumulator +
          employee.reduce(
            (empAccumulator, emp) => empAccumulator + emp.calculatedSalary,
            0
          ),
        0
      );
      debugger
      const newTotalInteres = (selectedInvoice?.interest && selectedInvoice?.interest>0) ? newTotalSum *  (selectedInvoice.interest / 100) : 0;
      const newTotalSumInteres =  newTotalSum + newTotalInteres;
      
      const newFilteredData = Object.keys(selectedInvoice?.detail)
        .filter((percent) => Number(percent) !== 0)
        .map((percent) => ({
          percent,
          totalSalary: selectedInvoice?.detail[percent].reduce(
            (accumulator, employee) => accumulator + employee.calculatedSalary,
            0
          ),
          cantEmpleados: selectedInvoice?.detail[percent].length,
        }));
      
        settotalInteres(newTotalInteres)
        setTotalSumInteres(newTotalSumInteres)
      setTotalSum(newTotalSum);
      setFilteredData(newFilteredData);
    }
  }, [selectedInvoice]);

  return (
    <>
      <Modal
        centered
        footer=""
        open={showOpen}
        onCancel={() => setShowOpen(false)}
        width={800}
        closable={true}
      >
        {selectedInvoice && (
          <div
            ref={reportTemplateRef}
            style={{
              padding: 10,
              marginBottom: "20px",
              backgroundColor: "#eaeaea",
            }}
          >
            <Row style={{ height: "100px" }}>
              <Col
                span={24}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Image src={logoImage} height={50} preview={false} />
                <div
                  style={{
                    justifyContent: "center",
                    display: "flex",
                    width: "50%",
                    flexDirection: "column",
                  }}
                >
                  {selectedInvoice?.tipoFactura === "formacion" ? (
                    <>
                      <strong>
                      Cuenta Corriente N 191-070-040697/3
                      </strong>
                      <strong style={{ marginTop: "5px" }}>
                        CBU: 19100704-55007004069732
                      </strong>
                    </>
                  ) : (
                    <>
                      <strong>
                        Cuenta Corriente N 191-070-015307-7, Sucursal Tribunales Banco Credicoop Ltda. Av. Corrientes 1574
                      </strong>
                      <strong style={{ marginTop: "5px" }}>
                        CBU: 1910070001530700000000
                      </strong>
                    </>
                  )}
                </div>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Card
                  size="small"
                  style={{ textAlign: "left", marginBottom: "5px" }}
                  title="Datos de facturación"
                >
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div>
                      <p>
                        <strong>Empresa: </strong>
                        {selectedInvoice.company.name}
                      </p>
                      <p>
                        <strong>
                          Factura Nº: {selectedInvoice.invoiceNumber}
                        </strong>
                      </p>
                      <p style={{ fontWeight: "bold" }} >
                        Tipo Factura: {(selectedInvoice?.tipoFactura && selectedInvoice?.tipoFactura ==="formacion" ) ? 'Por Formacion': 'Sindical'} 
                      </p>
                    </div>
                    <div>
                      <p>
                        <strong>Fecha de solicitud: </strong>
                        {moment(Date(selectedInvoice.createdAt)).format(
                          "DD/MM/YYYY"
                        )}
                      </p>
                      <p>
                        <strong>Período a facturar: </strong>
                        {moment(selectedInvoice.period[0]).format(
                          "DD/MM/YYYY"
                        ) +
                          " - " +
                          moment(selectedInvoice.period[1]).format(
                            "DD/MM/YYYY"
                          )}
                      </p>
                    </div>
                  </div>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Card
                  size="small"
                  title="Medio de pago"
                  style={{ textAlign: "left", marginBottom: "5px" }}
                >
                  <Checkbox>Efectivo</Checkbox>
                  <Checkbox>Cheque</Checkbox>
                  <Checkbox>Transferencia</Checkbox>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                {selectedInvoice.detail &&
                  Object.keys(selectedInvoice.detail).length > 0 && (
                    <Card title="Detalle" size="small">
                      <Table
                        style={{
                          maxHeight: "410px",
                          overflowY: "auto",
                          marginBottom: "20px",
                          marginTop: "20px",
                        }}
                        pagination={false}
                        dataSource={filteredData}
                        columns={[
                          {
                            title: "Porcentaje",
                            dataIndex: "percent",
                            key: "percent",
                            render: (value) => `${value} %`,
                          },
                          {
                            title: "Cant. Empleados",
                            dataIndex: "cantEmpleados",
                            key: "cantEmpleados",
                            align: "right",
                          },
                          {
                            title: "Total Acumulado",
                            dataIndex: "totalSalary",
                            key: "totalSalary",
                            align: "right",
                            render: (value) =>
                              `$ ${value.toLocaleString("de-DE")}`,
                          },
                        ]}
                      />
                    </Card>
                  )}
                <div
                  style={{
                    justifyContent: "end",
                    display: "flex",
                    flexDirection:"column",
                    marginTop: "5px",
                    textAlign:"right",
                  }}
                >
                    <h5 style={{ borderBottom: "1px dashed #ccc", padding:"10px 20px",}}>SubTotal:$ {parseFloat(totalSum).toFixed(1).toLocaleString("de-DE")}</h5>
            <h5 style={{ borderBottom: "1px dashed #ccc", padding:"10px 20px",}}>Intereses ({selectedInvoice.interest}%) : ${parseFloat(totalInteres).toFixed(1).toLocaleString("de-DE")}</h5>
            <h4 style={{ padding:"5px 20px",}}>Total:$ {parseFloat(totalSumInteres).toFixed(1).toLocaleString("de-DE")}</h4>
                </div>
              </Col>
            </Row>
          </div>
        )}

        <Link
          to={"#"}
          onClick={() => {
            setShowOpen(false);
            handleGeneratePdf();
          }}
          className="btn btn-warning shadow btn-xs sharp me-3"
        >
          <i className="fas fa-print"></i>
        </Link>
      </Modal>
    </>
  );
};

export default ModalPreviewPDF;
